export default "__VITE_ASSET__BK0s6w_t__"